<div class="mb-3">
  <label class="mb-0">{{ 'GROUP' | translate }}</label>
  <select (change)="selectGroup($event)" class="form-control mb-0" [(ngModel)]="selectedGroup">
    @for (group of availableGroups; track group) {
      <option [value]="group.code">{{group.description}}</option>
    }
  </select>
</div>
